import { render, staticRenderFns } from "./ManageTaskDetail.vue?vue&type=template&id=4ca392d1&scoped=true"
import script from "./ManageTaskDetail.vue?vue&type=script&lang=js"
export * from "./ManageTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ManageTaskDetail.vue?vue&type=style&index=0&id=4ca392d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca392d1",
  null
  
)

export default component.exports